import _ from 'lodash';
import isMobile from '@/lib/navigation-is-mobile.js';

export default {
	data() {
		return {
			mobile: false,
		};
	},
	methods: {
		onResize() {
			this.mobile = isMobile();
		},
	},
	created() {
		this.onResize();
		this.debouncedOnResize = _.debounce(this.onResize, 100);

		window.addEventListener('resize', this.debouncedOnResize);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.debouncedOnResize);
	},
};
